const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  deptName: state => state.user.deptName,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  deptList: state => state.dept.deptList,
  phonenumber: state => state.user.phonenumber,
  projectList: state => state.project.projectList,
  userId: state => state.user.userId,
  userName: state => state.user.userName,
  companyCheck: state => state.user.companyCheck,
  productCheck: state => state.user.productCheck,
  mainAccountInfo: state => state.user.mainAccountInfo,
  hasChildAccount: state => state.user.hasChildAccount,
}
export default getters